import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Dropdown, Row, Col } from 'react-bootstrap'
import { v4 as uuidv4 } from 'uuid'
import companyLogo from '../../../img/company.png'
import { useMediaQuery } from 'react-responsive'
import { setActiveCompany } from '../../../redux/actions/active-company'
import { changeUniversalModal } from '../../../redux/actions/universal'

import './style.scss'

const Index = ({ setMobileMainMenuOpen, mobileCompaniesMenuOpen, setMobileCompaniesMenuOpen}) => {

    const dispatch = useDispatch()

    const history = useHistory()
    const location = useLocation()

    const [open, setOpen] = useState(false)
    const companies = useSelector(state => state && state.user && state.user.details && state.user.details.companies)
    const loading = useSelector(state => state && state.user && state.user.fetchUserDetails.loading)

    const company = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany)
    const companiesLoading = useSelector(state => state && state.user && state.user.fetchCompanies.loading)

    const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

    const clickNewSpace = () => {
        dispatch(changeUniversalModal({newSpaceModal: true}))
    }

    const selectCompany = company => {
        dispatch(setActiveCompany(company))
        if(isMobile){
            setMobileCompaniesMenuOpen(false)
        }
        if(location.pathname === "/dashboard/kunde/:id"){
            history.push('/dashboard/kunder')
        } else if(location.pathname === '/dashboard/liste/:id'){
            history.push('/dashboard/lister')
        }
        setOpen(false)
    }

    const handleMobileOpen = () => {
        if(!loading && !companiesLoading){
            if(isMobile){
                setMobileMainMenuOpen(false)
                setMobileCompaniesMenuOpen(!mobileCompaniesMenuOpen)
            } else {
                setOpen(!open)
            }
        }
    }

    const renderDropdownIcon = () => {
        if(!loading && !companiesLoading){
            if(!companies || companies && companies.length > 0){
                return <i class="fad fa-angle-down"></i>
            } else {
                return null
            }
        } else {
            return null
        }
    }

    const renderDropdownCompanyDisplay = () => {
        if(loading || companiesLoading){
            return "Laster.."
        } else{
            if(company && company.name){
                return company && company.name
            } else {
                return "Ingen selskap"
            }
        }
    }
    
    return(
        <>
        <Dropdown show={companies && companies.length > 1 ? open:false} className={`company-selection-dropdown ${isMobile ? "mobile":"desktop"} ${mobileCompaniesMenuOpen ? 'mobileOpen':''} ${!loading && companiesLoading && companies && companies.length > 1 ? "droppable":""}`}>
            <Dropdown.Toggle onClick={() => handleMobileOpen()} className="dropdown-toggle notification-button" id="dropdown-basic">
            {isMobile ? 
                <Row className="selection-row">
                    <Col className="details-col">
                        <label className="active-company">
                            {renderDropdownCompanyDisplay()}
                        </label>
                    </Col>
                    <Col className="selection-thumbnail-col text-right">
                        <img alt="Virksomhet" className="thumbnail" src={companyLogo}/>
                    </Col>
                </Row>
            :
            <Row className="selection-row">
                    <Col className="selection-thumbnail-col text-center">
                        <i class="fad fa-building"></i>
                    </Col>
                    <Col className="details-col my-auto">
                        <label className="active-company">
                            {renderDropdownCompanyDisplay()}
                            {renderDropdownIcon()}
                        </label>
                    </Col>
                </Row>
            }
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-selection">
            <div className="companies-container">
            <h3 className="companies-title">Alle selskaper</h3>
                {loading || companiesLoading ?
                    null
                :
                <div className="selection-container">
                    {companies && companies.length > 0 ? companies.map((company, index, arr) => {
                        if(company.name && company.id){
                            return(
                                <div className={`single-company-container ${index === arr.length - 1 ? "last":""}`}>
                                    <Row key={uuidv4()} className="single-company-row" onClick={() => selectCompany(company)}>
                                        <Col className="thumbnail-col my-auto">
                                            <i class="fad fa-building"></i>
                                        </Col>
                                        <Col className="name-col my-auto">
                                            <h5 className="company-title">{company.name}</h5>
                                        </Col>
                                        <Col className="arrow-col text-right">
                                            <i className="right-arrow fas fa-angle-right"></i>
                                        </Col>
                                    </Row>
                                </div>
                            )
                        }
                    }):null}
                </div>
                }
                </div>
            </Dropdown.Menu>
        </Dropdown>
        {isMobile && mobileCompaniesMenuOpen && !loading && !companiesLoading ? 
        <section className={`mobile-company-dropdown ${mobileCompaniesMenuOpen ? 'open':''}`}>
            <div className="inner-mobile-company-dropdown">
                <Row className="upper-mobile-row">
                    <Col className="title-col text-left my-auto">
                        <h3 className="companies-title">Alle selskaper</h3>
                    </Col>
                    <Col className="button-col text-right my-auto">
                        <button onClick={() => clickNewSpace()} className="new-space-button"><i class="fad fa-plus"></i> Foretak</button>
                    </Col>
                </Row>
                <div className="selection-container">
                    {companies && companies.length > 0 ? companies.map((company, index, arr) => {
                        if(company.name && company.id){
                            return(
                                <div className={`single-company-container ${index === arr.length - 1 ? "last":""}`}>
                                    <Row key={uuidv4()} className="single-company-row" onClick={() => selectCompany(company)}>
                                        <Col className="thumbnail-col text-center my-auto">
                                            <i class="fad fa-building"></i>
                                        </Col>
                                        <Col className="name-col my-auto">
                                            <h5 className="company-title">{company.name}</h5>
                                        </Col>
                                        <Col className="arrow-col text-right">
                                            <button><i className="right-arrow fas fa-angle-right"></i></button>
                                        </Col>
                                    </Row>
                                </div>
                            )
                        }
                    }):null}
                </div>
            </div>
        </section>
        :null}
        </>
    )
}

export default Index